import { Attributes, JSX } from 'preact'
import classnames from 'classnames'

interface Props {
  className?: string
  children: JSX.Element[]
  getItemProps?: (idx: number) => Attributes
}

export default function List(props: Props) {
  return (
    <ul className={classnames('main-menu-list', props.className)}>
      {props.children.map((item, idx) => (
        <li className='main-menu-list__item' key={idx} {...props.getItemProps?.(idx)}>
          {item}
        </li>
      ))}
    </ul>
  )
}
